import { render } from "./CreatePayment1.vue?vue&type=template&id=060cbba0"
import script from "./CreatePayment1.vue?vue&type=script&lang=js"
export * from "./CreatePayment1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__